import { useEffect } from 'react';

const Spinner = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div style={containerStyle}>
      <div style={loaderStyle}>
        <div className="dot" style={dotStyle}></div>
        <div className="dot" style={{ ...dotStyle, animationDelay: '0.2s' }}></div>
        <div className="dot" style={{ ...dotStyle, animationDelay: '0.4s' }}></div>
      </div>
      <p style={textStyle}>Loading...</p>
    </div>
  );
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  color: '#333',
  overflow: 'hidden',
  margin: 0,
  padding: 0,
};

const loaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '80px',
};

const dotStyle = {
  width: '16px',
  height: '16px',
  backgroundColor: '#3498db',
  borderRadius: '50%',
  animation: 'bounce 1.2s infinite ease-in-out',
};

const textStyle = {
  marginTop: '16px',
  fontSize: '18px',
  fontWeight: '500',
  fontFamily: 'Arial, sans-serif',
  color: '#555',
  margin: 0,
};

const style = document.createElement('style');
style.innerHTML = `
  @keyframes bounce {
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;
document.head.appendChild(style);

export default Spinner;
